<template>
  <main class="bg-primary rounded-lg">
    <slot />
  </main>
</template>

<script setup lang="ts">
defineOptions({
  name: 'b-main-content',
})
</script>
